import http from "@/http-common"

class FormService {
  getHuboFormIframeUrl(token: string): Promise<any> {
    return http.get(`/auth/iframes/web-form/` + token)
  }

  getHuboAdhesionIframeUrl(token: string): Promise<any> {
    return http.get(`/auth/iframes/adhesion/` + token)
  }

  /**
   *
   * @param id // establishemnt_id OU contact_token pour chaudière appalaches
   * @returns
   */
  getHuboOpenFormIframeUrl(id: number | string): Promise<any> {
    return http.get(`/auth/iframes/open-form/` + id)
  }

  getSolicitationMetadata(type: string, token: string): Promise<any> {
    return http.post(`/auth/local-diffusers/solicitations/metadata`, {
      type: type,
      token: token,
    })
  }

  getProviderNameFromWebFormToken(token: string): Promise<any> {
    return http.get(`/auth/iframes/provider-name/web-form/` + token)
  }

  hasContactUskaAccount(token: string): Promise<any> {
    return http.get(`/accounts/is-contact-token-used/` + token)
  }

  getFormState(token: string): Promise<any> {
    return http.get(`/iframes/web-form/state/` + token)
  }
}

export default new FormService()
